const initState = {
  balance: 0,
  stakedPhnx: 0,
  activePortal: [],
  interest: 0,
  interestList: [],
  loading: true,
  totalStaked: 0,
  contractBalance: 0,
  dashboardData: null,
};

const dashboardReducer = (state = initState, action) => {
  switch (action.type) {
    case "GET_DASHBOARD_DATA":
      return {
        ...state,
        dashboardData: action.payload,
      };
    case "getBalance":
      return {
        ...state,
        balance: action.payload,
      };
    case "stakerData":
      return {
        ...state,
        stakedPhnx: action.payload.stakedPhnx,
        activePortal: action.payload.activePortal,
        loading: false,
      };
    case "getInterest":
      return {
        ...state,
        interest: action.payload,
      };
    case "interestList":
      return {
        ...state,
        interestList: action.payload,
      };
    case "setLoading":
      return {
        ...state,
        loading: false,
      };
    case "getTotalStaked":
      return {
        ...state,
        totalStaked: action.payload,
      };
    case "getContractBalance":
      return {
        ...state,
        contractBalance: action.payload,
      };

    case "LOGOUT_APP":
      return {
        initState,
      };
    default:
      return state;
  }
};

export default dashboardReducer;
